module.exports = __webpack_public_path__ + "static/img/OXFORD-MDF.fe8d60d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/OXFORD-MDF.png
// module id = PYhd
// module chunks = 0